export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/starRibbon.15301333.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};